export {NotificationRpcService} from './notification.rpc.service'

export enum NotificationActions {
  Add = "Add",
  Remove = "Remove",
  Read= "Read",
  Clear = "Clear",
  Get = "Get"
}

export interface Notice {
  nid?: string;
  title: string;
  description: string;
  dismissed: boolean;
  is_read: boolean;
  data?: any;
  created_by: string;
  created_on: Date;
}
